import store from '@state/store'
import { lazyLoadView } from '@utils/app/lazy-load-routes'
import { setInfo } from '@utils/app/select-info'
import toggle from '@utils/design/toggle-info'

export default [
  {
    path: '/device/state',
    name: 'Device State',
    component: () => lazyLoadView(import('@views/device-state/device-state')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        toggle(false)

        Promise.all([
          store.dispatch('device/fetchDevices', {
            clearCache: false,
          }),
          store.dispatch('entityDescription/fetchEntityDescriptions', {
            clearCache: false,
          }),
          store.dispatch('deviceEventCurrent/fetchEventCurrents', {
            clearCache: true,
          }),
          store.dispatch('infoDetails/selectDetailsDefault', {
            defaultObject: null,
          }),
          store.dispatch('deviceGroups/fetchGroups', { clearCache: true }),
          store.dispatch('info/setInfo', setInfo(routeTo.name)),
          store.dispatch('info/setCompact', { compact: false }),
        ])
          .then(() => {
            // Continue to the route.
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: 'Login', params: { resource: 'Device State' } })
          })
      },
    },
  },

  {
    path: '/device/state/minimal',
    name: 'Device State',
    component: () => lazyLoadView(import('@views/device-state/device-state')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        toggle(false)

        Promise.all([
          store.dispatch('device/fetchDevices', {
            clearCache: false,
          }),
          store.dispatch('entityDescription/fetchEntityDescriptions', {
            clearCache: false,
          }),
          store.dispatch('deviceEventCurrent/fetchEventCurrents', {
            clearCache: true,
          }),
          store.dispatch('infoDetails/selectDetailsDefault', {
            defaultObject: null,
          }),
          store.dispatch('deviceGroups/fetchGroups', { clearCache: true }),
          store.dispatch('info/setInfo', setInfo(routeTo.name)),
          store.dispatch('info/setCompact', { compact: true }),
        ])
          .then(() => {
            // Continue to the route.
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: 'Login', params: { resource: 'Device State' } })
          })
      },
    },
  },

  {
    path: '/device/state/history/',
    name: 'Device State History',
    component: () => lazyLoadView(import('@views/device-state/device-state-history')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        toggle(false)

        Promise.all([
          store.dispatch('device/fetchDevices', {
            clearCache: false,
          }),
          store.dispatch('deviceActivity/fetchActivities', { clearCache: false }),
          store.dispatch('entityDescription/fetchEntityDescriptions', {
            clearCache: false,
          }),
          store.dispatch('infoDetails/selectDetailsDefault', {
            defaultObject: null,
          }),
          store.dispatch('deviceGroups/fetchGroups', { clearCache: true }),
          store.dispatch('info/setInfo', setInfo(routeTo.name)),
        ])
          .then(() => {
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: 'Login', params: { resource: 'Device State' } })
          })
      },
    },
  },
  {
    path: '/device/state/history/detail/:deviceId/:deviceName',
    name: 'Device State History Detail',
    component: () =>
      lazyLoadView(import('@views/device-state/device-state-history-detail')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        toggle(false)

        Promise.all([
          store.dispatch('deviceInsights/getDeviceEvents', {
            clearCache: true,
            dateRange: store.getters['filters/dateRangeWebFilters'],
            deviceId: routeTo.params.deviceId,
          }),

          store.dispatch('deviceInsights/getDeviceStateAggregateHour', {
            clearCache: true,
            dateRange: store.getters['filters/dateRangeWebFilters'],
            deviceId: routeTo.params.deviceId,
          }),

          store.dispatch('deviceCycle/fetchCycles', {
            clearCache: true,
            dateRange: store.getters['filters/dateRangeWebFilters'],
            deviceId: routeTo.params.deviceId,
          }),

          store.dispatch('deviceEventCurrent/fetchEventCurrents', {
            clearCache: true,
          }),

          store.dispatch('entityDescription/fetchEntityDescriptions', {
            clearCache: false,
          }),

          store.dispatch('infoDetails/selectDetailsDefault', {
            defaultObject: null,
          }),
          store.dispatch('deviceGroups/fetchGroups', { clearCache: true }),
          store.dispatch('deviceActivity/fetchActivities', { clearCache: false }),
          store.dispatch('info/setInfo', setInfo(routeTo.name)),
        ])
          .then(() => {
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: 'Login', params: { resource: 'Device State' } })
          })
      },
    },
  },
]
